import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'

@Component({
  selector: 'chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.css'],
})
export class ChipComponent implements OnInit {
  @Input() public checked: boolean
  @Input() public value: any
  @Output() public onChange: EventEmitter<any> = new EventEmitter()

  constructor() {}

  ngOnInit() {}

  public checkboxChanged(event: any) {
    this.onChange.emit(event)
  }
}
